export default {
  ads: {
    tower: 525839,
    mobile: 633918,
    showAdAfterNthPicture: 7,
  },
};
